import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import styles from './careerContentCardComponent.scss'
import PropTypes from 'prop-types'
import GradientHr from '../gradientHr/gradientHrComponent'

export function CareerContentCard (props: Props) {
  const { t } = props
  return (
    <section className={styles.cardContainer} key={props.key}>
      <h2 className={styles.cardTitle}>{props.title.toLowerCase()}</h2>
      <GradientHr />
      <p>{props.description}</p>
      <dl className={styles.detailsList}>
        <dt>{t('career:salary')}</dt>
        <dd>{props.salaryRange}</dd>
        <dt>{t('career:educationReqs')}</dt>
        <dd>{t(`career:${props.educationReqs}`)}</dd>
        <dt>{t('career:demand')}</dt>
        <dd>{props.demand ? t('career:inDemand') : t('career:noDemand')}</dd>
        <dt>{t('career:mobility')}</dt>
        <dd>
          {props.mobility ? t('career:hasMobility') : t('career:noMobility')}
        </dd>
      </dl>
    </section>
  )
}
CareerContentCard.propTypes = {
  t: PropTypes.func.isRequired,
  key: PropTypes.number,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  salaryRange: PropTypes.string.isRequired,
  demand: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  mobility: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  educationReqs: PropTypes.oneOf([
    'highschool',
    'associates',
    'bachelors',
    'law',
    'masters'
  ]).isRequired
}

export default compose(pure, translate())(CareerContentCard)



// WEBPACK FOOTER //
// ./src/components/careerContentCard/careerContentCardComponent.js